import { BenefitPeriodLength } from 'types/graph';

export const BENEFIT_PERIOD_LABEL = 'Select a Benefit Period';
export const BENEFIT_PERIOD_OPTIONS = [
  { value: BenefitPeriodLength.TwoYears, label: '2 years' },
  { value: BenefitPeriodLength.FiveYears, label: '5 years' },
  { value: BenefitPeriodLength.TenYears, label: '10 years' },
  { value: BenefitPeriodLength.ToAge_65, label: 'up to age 65' },
  { value: BenefitPeriodLength.ToAge_67, label: 'up to age 67' },
];

export const RECOMMENDATION_TITLE = 'Our Recommendation';
export const RECOMMENDATION_TEXT_1 =
  "A policy that covers you up until retirement age, (especially if you're younger and in good health).";
export const RECOMMENDATION_TEXT_2 =
  'Otherwise, a 5-year benefit period may be good value coverage.';
